export const SPARE_PARTS_DOMAIN_KEY = 'spareParts';
